module.exports = __webpack_public_path__ + "img/car_sendai01.c6eeea16.jpg";